import { computed } from 'vue';
import DeviceDetector from 'device-detector-js';

/**
 * Possible device types returned by device-detector-js.
 * The final `string` allows forward-compatibility with new values.
 */

export function useDevice() {
    // Guard for SSR: navigator is not defined on the server
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';

    // Initialize parser
    const detector = new DeviceDetector();

    // Parse user agent string if available
    const parsed = ua ? detector.parse(ua) : null;

    // Extract device type, fallback to "desktop" if undefined
    const type = parsed?.device?.type ?? 'desktop';

    // Computed booleans for device category
    // "smartphone" and "feature phone" are treated as mobile
    const isMobile = computed(() => ['smartphone', 'feature phone'].includes(type));

    // Tablet flag
    const isTablet = computed(() => type === 'tablet');

    // Everything else defaults to desktop
    const isDesktop = computed(() => type === 'desktop');

    // Expose device information and flags to consumers
    return {
        info: parsed,
        type,
        isMobile,
        isTablet,
        isDesktop
    };
}
